import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import { useAuth } from '../../context/AuthContext'

const Layout = () => {
  const { user } = useAuth()

  if (!user) {
    return (
      <div className="min-h-screen w-full">
        <Outlet />
      </div>
    )
  }

  return (
    <div className="min-h-screen w-full bg-gray-50" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <div className="flex w-full min-h-screen">
        <Sidebar />
        <main className="flex-1 w-full min-w-0 px-4 sm:px-5 md:px-6 py-4 md:py-6 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default Layout